<template>
    <div>
        <h3 class="mt-3 mb-4 mk-masteragreement">Master Agreemens</h3>
        <hr />

        <div
            class="row m-2"
            style="border-bottom: 1px solid #efefef;"
            v-for="masterAgreement in masterAgreements"
            :key="masterAgreement.id"
        >
            <div class="col-10">
                <p>
                    <strong>Created At: </strong>
                    {{
                        moment(
                            masterAgreement.created_at,
                            "YYYY-MM-DD HH:mm:ss"
                        ).format("DD/MM/YYYY HH:mma")
                    }}
                </p>
            </div>
            <div class="col-2 d-flex justify-content-end">
                <a
                    :href="masterAgreement.agreement_pdf_url"
                    v-if="masterAgreement.agreement_pdf_url"
                    ><i class="far fa-eye"></i
                ></a>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    props: {
        business: {
            type: Object
        }
    },
    mounted() {
        this.masterAgreements = this.business.master_agreements;
    },
    data() {
        return {
            masterAgreements: []
        };
    }
};
</script>
